import clsx from 'clsx';
import styles from './index.module.scss';
import { Route, Routes, useParams } from 'react-router-dom';
import CameraPermissionStep from './CameraPermissionStep';
import FlatSurfaceStep from './FlatSurfaceStep';
import { Navigate } from 'react-router-dom';
import DriverUploadDotMedicalPage from './DriverUploadDotMedicalPage';
import LicenseCameraScan from 'features/Driver/LicenseCameraScan';
import DriverUploadGenericDocumentPage from './DriverUploadGenericDocumentPage';
import { DocumentTypeEnum } from 'common/document/enums/document-type.enum';

export interface ScanPageProps {
  className?: string;
}

function ScanPage(props: ScanPageProps) {
  const { documentRequestId, documentId, documentType, documentTypeEnum } =
    useParams<{
      documentRequestId: string;
      documentType: string;
      documentId: string;
      documentTypeEnum: DocumentTypeEnum;
    }>();

  if (!documentRequestId) return <div>No documentRequestId found</div>;
  if (!documentType) return <div>No documentType found</div>;
  if (!documentTypeEnum) return <div>No documentTypeEnum found</div>;
  if (!documentId) return <div>No document found</div>;

  return (
    <div className={clsx(styles.root, props.className)}>
      <Routes>
        <Route
          path="step-1"
          element={
            <CameraPermissionStep
              documentRequestId={documentRequestId}
              documentType={documentType}
              documentId={documentId}
              documentTypeEnum={documentTypeEnum}
            />
          }
        />
        <Route
          path="step-2"
          element={
            <FlatSurfaceStep
              documentRequestId={documentRequestId}
              documentType={documentType}
              documentId={documentId}
              documentTypeEnum={documentTypeEnum}
            />
          }
        />
        {documentType === 'license' && (
          <>
            <Route
              path="scan"
              element={
                <LicenseCameraScan
                  key="scan"
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                />
              }
            />
            <Route
              path="manual-upload"
              element={
                <LicenseCameraScan
                  key="manual-upload"
                  useManulaUpload
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                />
              }
            />
          </>
        )}
        {documentType === 'dot-med' && (
          <>
            <Route
              path="scan"
              element={
                <DriverUploadDotMedicalPage
                  key="scan"
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                />
              }
            />
            <Route
              path="manual-upload"
              element={
                <DriverUploadDotMedicalPage
                  key="manual-upload"
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                  useManulaUpload
                />
              }
            />
          </>
        )}
        {documentType === 'generic' && (
          <>
            <Route
              path="scan"
              element={
                <DriverUploadGenericDocumentPage
                  key="scan"
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                  documentType={documentTypeEnum!}
                  documentTypeEnum={documentTypeEnum}
                />
              }
            />
            <Route
              path="manual-upload"
              element={
                <DriverUploadGenericDocumentPage
                  key="manual-upload"
                  documentRequestId={documentRequestId}
                  documentId={documentId}
                  useManulaUpload
                  documentType={documentTypeEnum!}
                  documentTypeEnum={documentTypeEnum}
                />
              }
            />
          </>
        )}
        <Route path="*" element={<Navigate to="step-1" replace={true} />} />
      </Routes>
    </div>
  );
}

export default ScanPage;
